<div class="modal-content" data-testid="SUBSYS2_LOADER_BOX">
	<img class="logo-loading" [src]="LOADER_URL" alt="loading" data-testid="SUBSYS2_LOADER_IMG" />
</div>